module.exports = __webpack_public_path__ + "img/stop.910a5c9f.svg";